module.exports = __webpack_public_path__ + "img/ergebniseingabe.2a835481.png";